const SUCCESS = 'Success'
const MASS_CHANGE = 'Mass Change'
const CANCELLED = 'Cancelled'
const FAILURE = 'Failure'

const FILE_FEED = 'File Feed'
const FILE_UPLOAD = 'File Upload'

export const IMPORT_TYPES = {
  FILE_FEED,
  FILE_UPLOAD,
}

export const IMPORT_STATUSES = {
  SUCCESS,
  MASS_CHANGE,
  FAILURE,
  CANCELLED,
}
